import { useState, useEffect } from 'react';
import axios from 'axios';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';

export const useMarine = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    name: "", 
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/marine/list", filter)
      setItems(response.data.marines);
      setTotal(response.data.total);
      return response.data.marines
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };


      const response = await automobyApi.post("/marine/all", requestData)
      setItems(response.data.marines);
      setTotal(response.data.total);
      return response.data.marines
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/marine/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (marine, count) => {
    try {
      const requestData = {
        marine: marine,
        count: count,
      };

      const response = await automobyApi.post("/marine/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/marine/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          marine_id: id
        };
        const response = await automobyApi.post(`/marine/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  }

  const updateLocal = async (marine) => {
    setItems(items.map(item =>
      item.id === marine.id ? marine : item
    ));
  }
 

  const marineService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { marineService };
}